import React, { useState, useContext } from "react";
import GlobalContext from "../../../contexts/globalContext";
import ShareModal from "../../molecules/share-modal/shareModal";

// Styles //
import "./share-button.scss"

const ShareButton = (props: any) => {

    const Context = useContext(GlobalContext);
    const [visibility, setVisibility] = useState(false);
    const [currentUrl, setCurrentUrl] = useState("");

    const url = props.url ? encodeURIComponent(props.url) : typeof window !== 'undefined' ? window.location.href : '';

    const onClickShare = (e) => {
        if(props.login || props.login === undefined) {
            if (!Context.gigyaContext.gigyaAccount) {
                Context.gigyaContext.loginComfamaId!();
            } else {
                setCurrentUrl(url);
                setVisibility(e);
            }
        } else {
            setCurrentUrl(url);
            setVisibility(e);
        }
    };

    const popupCloseHandler = (e) => {
        setVisibility(e);
    };

    return (
        <div className="m-share-button">
          <div className="m-share-button__share">
              <div className="share">
                  <i className="icon-share"/>
                  <span onClick={() => {onClickShare(true)}}>
                      Compartir
                  </span>
              </div>
          </div>
          <ShareModal isOpen={visibility} onClose={popupCloseHandler} link={currentUrl} />
        </div>
    )

}

export default ShareButton;